import { render, staticRenderFns } from "./SpinnerComponent.vue?vue&type=template&id=0f223aaa&scoped=true&"
import script from "./SpinnerComponent.vue?vue&type=script&lang=js&"
export * from "./SpinnerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f223aaa",
  null
  
)

export default component.exports